import gql from 'graphql-tag';

const badgingBlacklistsQuery = gql`
  query GetBadgingBlacklists(
    $vin: String
    $sellerNumber: String
    $page: Int
    $pageSize: Int
  ) {
    badgingBlacklists(
      vin: $vin
      sellerNumber: $sellerNumber
      page: $page
      pageSize: $pageSize
    ) {
      total
      items {
        id
        vin
        sellerNumber
        status
        expirationDate
        notes
        createdAt
      }
    }
  }
`;

export default badgingBlacklistsQuery;
